import queryString from 'querystring';
import debounce from 'debounce';
import cookie from 'react-cookie';

export const TOGGLE_GROUP = 'TOGGLE_GROUP';
export const REQUEST_POSTS = 'REQUEST_POSTS';
export const RECEIVE_POSTS = 'RECEIVE_POSTS';
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const TOGGLE_SERVICE = 'TOGGLE_SERVICE';

const FETCH_DEBOUNCE_INTERVAL = 250;
const API_HOSTNAME = 'api.developertracker.com';
const API_PORT = 443;
let trackTiming = true;

const setSearchTerm = function setSearchTerm ( term ) {
    const currentQuery = queryString.parse( location.search.substr( 1 ) );

    if ( currentQuery.post ) {
        // Bad browser support
        // Reflect.deleteProperty( currentQuery, 'post' );
        delete currentQuery.post;

        let newPath = queryString.stringify( currentQuery );

        if ( newPath.length > 0 ) {
            newPath = `?${ newPath }`;
        } else {
            newPath = window.location.origin + window.location.pathname;
        }

        if ( window.history.pushState ) {
            window.history.pushState( {}, '', newPath );
        }
    }

    return {
        term,
        type: SET_SEARCH_TERM,
    };
};

const receivePosts = function receivePosts ( json ) {
    return {
        posts: json,
        receivedAt: Date.now(),
        type: RECEIVE_POSTS,
    };
};

const requestPosts = function requestPosts () {
    return {
        type: REQUEST_POSTS,
    };
};

const toggleGroupState = function toggleGroupState ( name ) {
    return {
        name,
        type: TOGGLE_GROUP,
    };
};

const toggleServiceState = function toggleServiceState ( name ) {
    return {
        name,
        type: TOGGLE_SERVICE,
    };
};

const updatePath = function updatePath ( getState, { replace = false } = {} ) {
    const state = getState();
    const querystringParameters = getQueryParameters( state.services, state.groups, state.search );
    const parsedQuerystring = queryString.stringify( querystringParameters );
    let locationSearch = `?${ parsedQuerystring }`;

    if ( parsedQuerystring.length === 0 ) {
        locationSearch = './';
    }

    if ( window.location.search === locationSearch ) {
        return;
    }

    // Search updates fire on every keystroke, so replace the current entry
    // instead of pushing one per character (avoids polluting browser history).
    if ( replace && window.history.replaceState ) {
        window.history.replaceState( {}, '', locationSearch );
    } else if ( window.history.pushState ) {
        window.history.pushState( {}, '', locationSearch );
    }
};

const getQueryParameters = function getQueryParameters ( services, groups, search ) {
    const currentQuery = queryString.parse( location.search.substr( 1 ) );
    let querystringParameters = {};
    let activeServices = [];
    let activeGroups = [];

    // If we have a post, don't keep anything else in the querystring
    if ( currentQuery.post ) {
        querystringParameters = {
            post: currentQuery.post,
        };

        return querystringParameters;
    }

    // Set search
    if ( typeof search !== 'undefined' && search.length > 0 ) {
        querystringParameters.search = search;
    }

    activeGroups = groups.items.filter( ( group ) => {
        return group.active;
    } );

    if ( activeGroups && activeGroups.length > 0 && activeGroups.length !== groups.items.length ) {
        querystringParameters[ 'groups[]' ] = activeGroups.map( ( group ) => {
            return group.name;
        } );
    }

    activeServices = services.items.filter( ( service ) => {
        return service.active;
    } );

    const cookieServices = cookie.load( 'services' );

    if ( activeServices && activeServices.length > 0 && activeServices.length !== services.items.length ) {
        querystringParameters[ 'services[]' ] = activeServices.map( ( service ) => {
            return service.name;
        } );
    }

    if ( services.items.length === 0 && cookieServices ) {
        querystringParameters[ 'services[]' ] = cookieServices;
    }

    return querystringParameters;
};

// eslint-disable-next-line max-params
const getPosts = function getPosts ( search, groups, services, dispatch ) {
    let urlPath = `/${ window.game }/posts`;
    const querystringParameters = getQueryParameters( services, groups, search );
    const parsedQuerystring = queryString.stringify( querystringParameters );

    if ( querystringParameters.post ) {
        urlPath = `${ urlPath }/${ querystringParameters.post }`;
    } else {
        urlPath = `${ urlPath }?${ parsedQuerystring }`;
    }

    const url = new URL(`https://${API_HOSTNAME}:${API_PORT}${urlPath}`);

    const startTime = new Date().getTime();
    dispatch( requestPosts() );

    fetch( url )
        .then((response) => {
            return response.json();
        })
        .then((posts) => {
            if ( window.ga && trackTiming ) {
                ga( 'send', {
                    hitType: 'timing',
                    timingCategory: 'Posts API',
                    timingVar: 'load',
                    timingValue: new Date().getTime() - startTime,
                    timingLabel: url.path,
                } );
            }
            console.log(posts);
            dispatch( receivePosts( posts.data ) );
        })
        .catch((requestError) => {
            dispatch( receivePosts( [] ) );
            console.error( requestError );
        });
};

const debouncedFetchPosts = debounce( getPosts, FETCH_DEBOUNCE_INTERVAL );

const fetchPosts = function fetchPosts ( state ) {
    const {
        search,
        groups,
        services,
     } = state;

    return ( dispatch ) => {
        debouncedFetchPosts( search, groups, services, dispatch );
    };
};

const fetchPostsImmediate = function fetchPostsImmediate ( state ) {
    const {
        search,
        groups,
        services,
     } = state;

    return ( dispatch ) => {
        getPosts( search, groups, services, dispatch );
    };
};

export const fetchPostsIfNeeded = function fetchPostsIfNeeded () {
    return ( dispatch, getState ) => {
        return dispatch( fetchPosts( getState() ) );
    };
};

export const search = function search ( searchTerm ) {
    return ( dispatch, getState ) => {
        dispatch( setSearchTerm( searchTerm ) );
        updatePath( getState, { replace: true } );

        return dispatch( fetchPosts( getState() ) );
    };
};

export const toggleGroup = function toggleGroup ( name ) {
    return ( dispatch, getState ) => {
        dispatch( toggleGroupState( name ) );
        updatePath( getState );

        return dispatch( fetchPostsImmediate( getState() ) );
    };
};

export const toggleService = function toggleService ( name ) {
    return ( dispatch, getState ) => {
        dispatch( toggleServiceState( name ) );
        updatePath( getState );

        return dispatch( fetchPostsImmediate( getState() ) );
    };
};
